"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

// DIRECTIVE #025: shared "Sign in for wholesale pricing" CTA. Renders
// where a price would otherwise be. Routes to /sign-in with a
// `redirect=` query param so the buyer lands back on the same page
// after auth.

type Variant = "inline" | "block";

export function SignInForPricesCTA({
  variant = "inline",
  className = "",
}: {
  variant?: Variant;
  className?: string;
}) {
  const pathname = usePathname() ?? "/catalog";
  const href = `/sign-in?redirect=${encodeURIComponent(pathname)}`;

  if (variant === "block") {
    return (
      <Link
        href={href}
        data-testid="sign-in-for-prices-cta"
        data-variant="block"
        className={
          "inline-flex items-center justify-center rounded-full bg-brand-teal/10 px-4 py-2 text-sm font-semibold text-brand-teal-dark hover:bg-brand-teal/20 " +
          className
        }
      >
        Sign in for wholesale pricing →
      </Link>
    );
  }

  return (
    <Link
      href={href}
      data-testid="sign-in-for-prices-cta"
      data-variant="inline"
      className={
        "text-xs font-semibold text-brand-teal-dark underline-offset-2 hover:underline " +
        className
      }
    >
      Sign in for prices →
    </Link>
  );
}

// Placeholder span used during the auth-state hydration window to
// preserve layout (no flash, no CLS). Sized to the typical price slot.
export function PriceGateSkeleton({
  width = "5rem",
  height = "1rem",
}: {
  width?: string;
  height?: string;
}) {
  return (
    <span
      data-testid="price-gate-skeleton"
      aria-hidden="true"
      className="inline-block animate-pulse rounded bg-gray-100"
      style={{ width, height }}
    />
  );
}
